<template>
  <path
    d="M16.59 9.00018H15V4.00018C15 3.45018 14.55 3.00018 14 3.00018H10C9.45 3.00018 9 3.45018 9 4.00018V9.00018H7.41C6.52 9.00018 6.07 10.0802 6.7 10.7102L11.29 15.3002C11.68 15.6902 12.31 15.6902 12.7 15.3002L17.29 10.7102C17.92 10.0802 17.48 9.00018 16.59 9.00018ZM5 19.0002C5 19.5502 5.45 20.0002 6 20.0002H18C18.55 20.0002 19 19.5502 19 19.0002C19 18.4502 18.55 18.0002 18 18.0002H6C5.45 18.0002 5 18.4502 5 19.0002Z"
  />
</template>
